module.exports = __webpack_public_path__ + "media/images/athletes/22-c06ffe863625f1f497291880aabbb56b.png";